import React, { useRef } from 'react';
import useGlobalError from '../../hooks/useGlobalError';

import styles from './Modal.module.postcss';

// 400 errors are mostly handled by auth components, and some may be expected
// Timeouts and fetch errors may be transient
// Auth errors are handled by auth components
const SUPPRESSED_ERRORS = [
  401,
  403,
  404,
  'TIMEOUT_ERROR',
  'FETCH_ERROR',
  'AUTH_ERROR'
];

// Normally suppressed, but show modal if the server returned a specific error message
const SHOW_IF_MESSAGE = [403];

function ErrorModal() {
  const { error, clearError } = useGlobalError();
  const lastErrorRef = useRef(null);

  const isSuppressed = SUPPRESSED_ERRORS.includes(error.status) || SUPPRESSED_ERRORS.includes(error.originalStatus);
  const hasMessage = error.message && error.message !== 'error';
  const isException = hasMessage && (SHOW_IF_MESSAGE.includes(error.status) || SHOW_IF_MESSAGE.includes(error.originalStatus));

  if (!error.status || (isSuppressed && !isException)) {
    return null;
  }

  // Don't show the same error message repeatedly
  const errorKey = `${error.status}-${error.message}`;
  if (lastErrorRef.current === errorKey) {
    return null;
  }
  lastErrorRef.current = errorKey;

  return (
    <div className={styles.ModalContainer}>
      <div className={styles.ModalContent + ' ' + styles.ModalContent__center + ' ' + styles.ModalContent__morePadding}>
        <h2>There was an error 🙁</h2>
        { hasMessage &&
          <p>{error.message}</p>
        }
        <button
          type='button'
          className='Button'
          onClick={clearError}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}

export default ErrorModal;
